/**
 * This file is used to define the jquery global that is used for the test bridge
 */
/* eslint-disable no-undef */
// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = require('jquery');
